import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class ZaiksService extends BaseService {

  constructor(protected http: HttpClient) {
    super();
  }
 
  public getReportZaiks(data): Observable<any> { 
    return this.http.post(this.getUrl('generateZaiksReport'), data, { responseType: 'blob' });
  }

}
